import React from 'react';
import { motion } from 'motion/react';

const shimmerTransition = {
  duration: 1.5,
  repeat: Infinity,
  ease: 'linear',
};

const ShimmerOverlay = ({ active = false }) => (
  <motion.div
    aria-hidden
    className="absolute inset-0 pointer-events-none"
    style={{
      background: 'linear-gradient(110deg, transparent 33%, rgba(255,255,255,0.4) 50%, transparent 66%)',
      backgroundSize: '200% 100%',
    }}
    animate={
      active
        ? { opacity: 1, backgroundPosition: ['200% 0', '-200% 0'] }
        : { opacity: 0, backgroundPosition: '200% 0' }
    }
    transition={active ? shimmerTransition : { duration: 0.2 }}
  />
);

export default ShimmerOverlay;
